import EntityDocumentsTab, {
  EQUIPMENT_DOCUMENT_SUGGESTIONS,
} from 'components/documents/entity-documents-tab.component'
import { useSelector } from 'react-redux'
import { RootState } from 'store'

const EquipmentDocuments = () => {
  const { selectedEquipment } = useSelector((state: RootState) => state.equipments)
  const associateId =
    selectedEquipment.equipmentId > 0 ? String(selectedEquipment.equipmentId) : ''

  return (
    <EntityDocumentsTab
      associateId={associateId}
      internalType="EquipmentDocument"
      documentTypeSuggestions={EQUIPMENT_DOCUMENT_SUGGESTIONS}
    />
  )
}

export default EquipmentDocuments
